<payee-chip-dropdown
  [placeholder]="'Adós adószáma'"
  [selected]="control.value"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="control.patchValue(null)"
>
  <payee-form-field width="wide">
    <span payee-label>Adós adószáma</span>
    <input
      payee-input
      [formControl]="control"
      (paste)="closeAfterPaste()"
    />
  </payee-form-field>
</payee-chip-dropdown>
